module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1338197c2aeb708ee8c324f6f2374835.png";